import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { getBrandLogo, getBrandLogoAlt } from "../../../utils/brandLogo";

import { emailPatternVerification } from "../../../helpers/emailPatternCheck.js";
import { sendRegisterEmail } from "../../../../src/services/emailRegister/emailRegisterServices.js";
import { AES } from "crypto-js";
import "../../../../src/pages/home/home.css";
import LoginImageMobile from "../../../images/login/lg-img-mob.png";
import LoginImage from "../../../images/login/lg-img.png";

import { GoogleOAuthProvider, googleLogout, useGoogleLogin } from '@react-oauth/google';
import { registerUser } from "../../../../src/services/emailRegister/emailRegisterServices.js";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { login, loginTemp } from '../../../features/auth/authSlice';
import { setForex } from "../../../features/forex/forexSlice.js";
import { setAppSettings } from "../../../features/appSettings/appSettingsSlice.js";
import { setDashboardCurrencyRx } from "../../../features/invoice/invoiceSlice";
import axios from "axios";
import moment from "moment";
import { ThreeDots } from "react-loader-spinner";
import Login from "../../auth/Login.jsx";

// google button




const CustomGoogleButton = ({ onSuccess, onError }) => {
        const login = useGoogleLogin({
                onSuccess: credentialResponse => {
                        onSuccess(credentialResponse);
                },
                onError: errorResponse => {
                        onError(errorResponse);
                }
        });

        return (



                <button
                        onClick={() => login()}
                        className="google-btn"
                >
                        {/* Google Logo */}
                        <svg
                                className="w-5 h-5"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                        >
                                <path
                                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                        fill="#4285F4"
                                />
                                <path
                                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                        fill="#34A853"
                                />
                                <path
                                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                        fill="#FBBC05"
                                />
                                <path
                                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                        fill="#EA4335"
                                />
                        </svg>

                        <span  >
                                Continue with Google
                        </span>
                </button>
        );
};


// end google button

const EmailLogin = () => {
        const [formData, setFormData] = useState({ email: "" });
        const [emailSent, setEmailSent] = useState(false);
        const [hasError, setHasError] = useState(false);
        const [errorMessage, setErrorMessage] = useState("");
        const [loading, setLoading] = useState(false);

        const setFieldError = (msg) => { setHasError(true); setErrorMessage(msg); };
        const clearFieldError = () => { setHasError(false); setErrorMessage(""); };

        const [otpDig1, setOtpDig1] = useState(null);
        const [otpDig2, setOtpDig2] = useState(null);
        const [otpDig3, setOtpDig3] = useState(null);
        const [otpDig4, setOtpDig4] = useState(null);
        const navigate = useNavigate();
        const emailSubmitHandler = async (e) => {
                clearFieldError();

                if (!formData.email.trim()) {
                        setFieldError("Email address is required.");
                        return;
                }

                if (!emailPatternVerification(formData.email)) {
                        setFieldError("Please enter a valid email address.");
                        return;
                }

                setLoading(true);
                try {
                        const emailResponse = await sendRegisterEmail(
                                formData.email,
                                global.config.getSubdomain()
                        );
                        if (emailResponse.status === "success") {
                                navigate(
                                        `/app/otp/verification/${encodeURIComponent(
                                                AES.encrypt(formData.email, "encryptionKey")
                                                        .toString()
                                                        .replace(/\//g, "%2F")
                                        )}`
                                );
                                setEmailSent(true);
                        } else if (emailResponse.status === "exists") {
                                setFieldError("This email is already registered. Please log in.");
                                setLoading(false);
                        } else {
                                setFieldError(emailResponse.message || "An error occurred. Please try again.");
                                setLoading(false);
                        }
                } catch (error) {
                        console.error('Email submit error:', error);
                        setFieldError(error.message || "An error occurred. Please try again.");
                        setLoading(false);
                }
        };

        const handleEmailChange = (e) => {
                setFormData({ ...formData, email: e.target.value });
                if (hasError) clearFieldError();
        };

        const validateOtp = async (e) => {
                if (otpDig1 && otpDig2 && otpDig3 && otpDig4) {
                }
        };

        // Login section
        const dispatch = useDispatch();

        const SUPER_ADMIN = 1;
        const ADMIN = 2;


        const domainName = window.location.hostname;
        const currentPort = window.location.port;
        const baseDomain = process.env.REACT_APP_BASE_DOMAIN || 'app.talenton.io';
        const isMasterPortal = domainName === baseDomain || domainName === 'localhost' || domainName === '127.0.0.1';


        const fetchForex = async () => {
                const settingsData = await axios.post(`api/forex/get`, { base_currency: "USD" }, {
                        headers: {}
                });
                await dispatch(setForex(settingsData.data.json));
                return settingsData.data.json;
        }

        const [googleSuccess, setGoogleSuccess] = useState(false);

        // Check for stored token on component mount
        useEffect(() => {
                // Token check logic if needed
        }, []);

        const handleLogout = () => {
                googleLogout(); // Logs out from Google session
                localStorage.removeItem('googleToken');
        };


        // end login section

        const getGoogleProfileFromToken = async (googleToken) => {
                try {
                        const googleProfile = await axios.get(`https://www.googleapis.com/oauth2/v3/userinfo`, {
                                headers: {
                                        Authorization: `Bearer ${googleToken}`,
                                }
                        });
                        return googleProfile.data;
                } catch (error) {
                        console.error('Error fetching Google profile:', error);
                        throw error;
                }
        }
        const handleSuccess = async (credentialResponse) => {
                setGoogleSuccess(true);
                try {
                        console.log('Login Success:', credentialResponse);
                        const googleProfile = await getGoogleProfileFromToken(credentialResponse.access_token);

                        // login part
                        localStorage.setItem('googleToken', credentialResponse.access_token);

                        try {
                                if (credentialResponse.access_token) {
                                        const result = await registerUser(googleProfile.email, googleProfile.email.split("@")[0], credentialResponse.access_token, googleProfile.email.split("@")[0], true);
                                        console.log('result', result);

                                        if (result.status === "success") {

                                                if (result.data.subDomain) {

                                                        if (currentPort === "3000") {
                                                                window.location.href = `http://${result.data.subDomain}.${domainName}:3000/app/google/auth/${credentialResponse.access_token}`;
                                                        } else {
                                                                window.location.href = `https://${result.data.subDomain}.${domainName}/app/google/auth/${credentialResponse.access_token}`;
                                                        }


                                                        // Login part


                                                        try {

                                                                const res = await fetch(`https://${result.data.subDomain}.${domainName}/api/user/google/login`, {
                                                                        method: "POST",
                                                                        headers: {
                                                                                "Content-Type": "application/json",
                                                                        },
                                                                        body: JSON.stringify({ email: googleProfile.email, password: credentialResponse.access_token }),
                                                                });
                                                                const data = await res.json();

                                                                if (data.token) {

                                                                        await dispatch(loginTemp(data));
                                                                        fetchForex();
                                                                        let settingsData;
                                                                        if (data.userType === 'x' || data.userType === 'Y') {

                                                                                settingsData = await axios.get(`https://${result.data.subDomain}.${domainName}/api/get/app-settings/${data.appId}`, {
                                                                                        headers: {
                                                                                                Authorization: `Bearer ${data.token}`,
                                                                                        }
                                                                                });

                                                                                const favIconData = await axios.get(`https://${result.data.subDomain}.${domainName}/api/view/owner/by/appid/${data.appId}`, {
                                                                                        headers: {
                                                                                                Authorization: `Bearer ${data.token}`,
                                                                                        },
                                                                                });

                                                                                let favIcon_fileName;
                                                                                let app_owner_name;
                                                                                let app_owner_id;
                                                                                let invoice_bg_fileName = null;
                                                                                if (favIconData && favIconData.data && favIconData.data.fav_icon) {
                                                                                        favIcon_fileName = favIconData.data.fav_icon;
                                                                                        app_owner_name = favIconData.data.commercial_name;
                                                                                        app_owner_id = favIconData.data._id;
                                                                                        invoice_bg_fileName = favIconData.data.invoice_bg || null;
                                                                                } else {
                                                                                        favIcon_fileName = "fav_icon_default.jpeg";
                                                                                        app_owner_name = "TalenTon";
                                                                                        app_owner_id = favIconData.data._id;
                                                                                }

                                                                                await dispatch(setAppSettings({ ...settingsData.data, favIcon: favIcon_fileName, invoiceBg: invoice_bg_fileName, app_ownername: app_owner_name, app_ownerid: app_owner_id }));
                                                                        } else {

                                                                                const userSettingsData = await axios.get(`https://${result.data.subDomain}.${domainName}/api/get/user-settings/${data._id}`, {
                                                                                        headers: {
                                                                                                Authorization: `Bearer ${data.token}`,
                                                                                        }
                                                                                });

                                                                                const favIconData = await axios.get(`https://${result.data.subDomain}.${domainName}/api/view/owner/by/appid/${data.appId}`, {
                                                                                        headers: {
                                                                                                Authorization: `Bearer ${data.token}`,
                                                                                        },
                                                                                });
                                                                                let favIcon_fileName;
                                                                                let app_owner_name;
                                                                                let app_owner_id;
                                                                                let invoice_bg_fileName = null;
                                                                                if (favIconData && favIconData.data && favIconData.data.fav_icon) {
                                                                                        favIcon_fileName = favIconData.data.fav_icon;
                                                                                        app_owner_name = favIconData.data.commercial_name;
                                                                                        app_owner_id = favIconData.data._id;
                                                                                        invoice_bg_fileName = favIconData.data.invoice_bg || null;
                                                                                } else {
                                                                                        favIcon_fileName = "fav_icon_default.jpeg";
                                                                                        app_owner_name = "TalenTon";
                                                                                        app_owner_id = favIconData.data._id;
                                                                                }

                                                                                settingsData = await axios.get(`https://${result.data.subDomain}.${domainName}/api/get/app-settings/${data.appId}`, {
                                                                                        headers: {
                                                                                                Authorization: `Bearer ${data.token}`,
                                                                                        }
                                                                                });
                                                                                if (settingsData.data !== null && (data.userType !== SUPER_ADMIN && data.userType !== ADMIN)) {
                                                                                        settingsData.data.timeFormat = userSettingsData?.data?.timeFormat ? userSettingsData?.data?.timeFormat : 12;
                                                                                }
                                                                                if (settingsData.data !== null) {
                                                                                        settingsData.data.currency = userSettingsData?.data?.currency ? userSettingsData?.data?.currency : "USD";
                                                                                        settingsData.data.timeZone = userSettingsData?.data?.timeZone ? userSettingsData?.data?.timeZone : null;
                                                                                }
                                                                                await dispatch(setAppSettings({ ...settingsData.data, favIcon: favIcon_fileName, invoiceBg: invoice_bg_fileName, app_ownername: app_owner_name, app_ownerid: app_owner_id }));
                                                                        }

                                                                        const response = await axios.get(`https://${result.data.subDomain}.${domainName}/api/dashboard/invoice-currency`, {
                                                                                headers: {
                                                                                        Authorization: `Bearer ${data.token}`,
                                                                                }
                                                                        });

                                                                        if (response.data.length > 0) {
                                                                                localStorage.setItem('DashboardCurrency', JSON.stringify(response.data[0]));
                                                                                dispatch(setDashboardCurrencyRx(response.data[0]));
                                                                        }
                                                                        let twoFactorEnabled;
                                                                        let twoFactorEnabledAt;
                                                                        if (settingsData && settingsData.data?.twoFa === true) {
                                                                                twoFactorEnabled = true;
                                                                                twoFactorEnabledAt = moment.tz(global.config.getTimeZone()).format();
                                                                        } else {
                                                                                twoFactorEnabled = localStorage.getItem('twoFactorEnabled');
                                                                                twoFactorEnabledAt = localStorage.getItem('twoFactorEnabledAt');
                                                                        }

                                                                        if (twoFactorEnabled && twoFactorEnabledAt) {
                                                                                if (twoFactorEnabled && Date.now() - twoFactorEnabledAt < 30 * 24 * 60 * 60 * 1000) {
                                                                                        // 2FA is enabled and it's within the 30-day timeframe
                                                                                        dispatch(login(data));

                                                                                        window.location.href = `https://${result.data.subDomain}.${domainName}/user/dashboard`;
                                                                                } else {
                                                                                        window.location.href = `https://${result.data.subDomain}.${domainName}/2fa`;
                                                                                }
                                                                        } else {
                                                                                dispatch(login(data));
                                                                                window.location.href = `https://${result.data.subDomain}.${domainName}/user/dashboard`;
                                                                        }
                                                                } else {
                                                                        // setErrorMessage(data);
                                                                        toast.error(data.message, {
                                                                                position: "bottom-right",
                                                                                autoClose: 1500,
                                                                                hideProgressBar: true,
                                                                                closeOnClick: true,
                                                                                pauseOnHover: true,
                                                                                draggable: true,
                                                                                progress: undefined,
                                                                                theme: "light",
                                                                        });
                                                                }
                                                                // setLoading(false);
                                                        } catch (err) {
                                                                console.error(err.message);
                                                                global.config.slackMessage(err.toString());
                                                                toast.error(err.message, {
                                                                        position: "bottom-right",
                                                                        autoClose: 1500,
                                                                        hideProgressBar: true,
                                                                        closeOnClick: true,
                                                                        pauseOnHover: true,
                                                                        draggable: true,
                                                                        progress: undefined,
                                                                        theme: "light",
                                                                });
                                                                // setLoading(false);
                                                        }


                                                        // Login part end


                                                }
                                                toast.success(result.data.message || "App owner registered successfully.", {
                                                        position: "bottom-right",
                                                        autoClose: 3000,
                                                        hideProgressBar: false,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                });
                                        } else if (result.status === "fail") {
                                                setGoogleSuccess(false);
                                                handleLogout();
                                                toast.error(result.message || "Something went wrong.", {
                                                        position: "bottom-right",
                                                        autoClose: 2500,
                                                        hideProgressBar: false,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                        theme: "light",
                                                });
                                        } else if (result.status === "failed") {
                                                setGoogleSuccess(false);
                                                handleLogout();
                                                toast.error(result.message || "Company name or email already exists.", {
                                                        position: "bottom-right",
                                                        autoClose: 2500,
                                                        hideProgressBar: false,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                        theme: "light",
                                                });
                                        }

                                }
                        } catch (error) {
                                console.error("Error:", error);
                                setGoogleSuccess(false);
                                toast.error("Failed to process Google login. Please try again.", {
                                        position: "bottom-right",
                                        autoClose: 2000,
                                });
                        }
                        // login part end




                } catch (error) {
                        console.error('Error processing login:', error);
                        setGoogleSuccess(false);
                        toast.error("Failed to authenticate with Google. Please try again.", {
                                position: "bottom-right",
                                autoClose: 2000,
                        });
                }
        };

        const handleError = () => {
                console.error('Login Failed');
        };



        return (


                isMasterPortal ?
                        (<>
                                <div className="top-logo-mobile">
                                        <Link to="/"><img src={getBrandLogo()} alt={getBrandLogoAlt()} /></Link>
                                </div>
                                <div className="home-login-inner">
                                        <div className="lg-lft">
                                                <img src={LoginImage} alt="desktop" className="desktop-lg-img" fetchpriority="high" />
                                                <img src={LoginImageMobile} alt="mobile" className="mobile-lg-img" />
                                        </div>
                                        <div className="home-rgt">
                                                <div className="top-logo">
                                                        <Link to="/"><img src={getBrandLogo()} alt={getBrandLogoAlt()} /></Link>
                                                </div>
                                        <div className="login-container">

                                                {googleSuccess === true ?

                                                        <>
                                                                <ThreeDots
                                                                        height="38"
                                                                        width="100"
                                                                        radius="9"
                                                                        color="blue"
                                                                        ariaLabel="three-dots-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClassName=""
                                                                        visible={true}
                                                                /></>
                                                        :
                                                        (
                                                                <>
                                                                        <GoogleOAuthProvider clientId="150723980220-pd771tque2fo4nao94qeid76fc1guuhq.apps.googleusercontent.com">
                                                                                <div className="login-header">Hi! Please enter your details</div>
                                                                                {/* Google button — hidden, enable later
                                                                                <div className="g-outer">
                                                                                        <CustomGoogleButton onSuccess={handleSuccess} onError={handleError} />
                                                                                </div>
                                                                                */}
                                                                                {!emailSent ? (
                                                                                        <>
                                                                                                {/* Divider hidden, enable later
                                                                                                <div className="divider">
                                                                                                        Or sign up with your email address
                                                                                                </div>
                                                                                                */}
                                                                                                <form onSubmit={(e) => { e.preventDefault(); emailSubmitHandler(); }}>
                                                                                                <input
                                                                                                        className={`email-input-btn ${hasError ? 'input-error' : ''}`}
                                                                                                        type="text"
                                                                                                        placeholder="name@company.com"
                                                                                                        value={formData.email}
                                                                                                        onChange={handleEmailChange}
                                                                                                        autoComplete="email"
                                                                                                        disabled={loading}
                                                                                                />
                                                                                                {hasError && errorMessage && (
                                                                                                        <span style={{ display: 'block', marginTop: '6px', fontSize: '13px', color: '#dc3545', fontWeight: 500, textAlign: 'right' }}>{errorMessage}</span>
                                                                                                )}
                                                                                                <div className="submit-button">
                                                                                                        <button type="submit" disabled={loading}>
                                                                                                                {loading ? (
                                                                                                                        <div className="outter-load-table">
                                                                                                                                <ThreeDots
                                                                                                                                        height="38"
                                                                                                                                        width="40"
                                                                                                                                        radius="9"
                                                                                                                                        color="white"
                                                                                                                                        ariaLabel="three-dots-loading"
                                                                                                                                        visible={true}
                                                                                                                                />
                                                                                                                        </div>
                                                                                                                ) : (
                                                                                                                        "Continue"
                                                                                                                )}
                                                                                                        </button>
                                                                                                </div>
                                                                                                </form>
                                                                                        </>
                                                                                ) : (
                                                                                        <>
                                                                                                1
                                                                                                <input
                                                                                                        type="number"
                                                                                                        onChange={(e) => setOtpDig1(e.target.value)}
                                                                                                />
                                                                                                2
                                                                                                <input
                                                                                                        type="number"
                                                                                                        onChange={(e) => setOtpDig2(e.target.value)}
                                                                                                />
                                                                                                3
                                                                                                <input
                                                                                                        type="number"
                                                                                                        onChange={(e) => setOtpDig3(e.target.value)}
                                                                                                />
                                                                                                4
                                                                                                <input
                                                                                                        type="number"
                                                                                                        onChange={(e) => setOtpDig4(e.target.value)}
                                                                                                />
                                                                                                <button onClick={validateOtp}>Submit</button>
                                                                                        </>
                                                                                )}
                                                                        </GoogleOAuthProvider>

                                                                        <div className="have-account">Already have an account?
                                                                                <Link to="/">Log in</Link>
                                                                        </div>
                                                                </>

                                                        )}



                                        </div>
                                        </div>
                                </div>
                        </>)

                        :

                        (

                                <>   <Login /> </>
                        )

        );
};

export default EmailLogin;